/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  home: {
    intro: {
      title:
        'Una innovación crucial para la rehabilitación facial basada en la realidad aumentada.',
      text: 'El MEPP es una herramienta innovadora de rehabilitación facial, destinada a tratar la parálisis facial. Proveniente de investigaciones colaborativas en Quebec, reúne a investigadores, pacientes, clínicos, tecnólogos y estudiantes para mejorar la calidad de vida de las personas afectadas por la parálisis facial. El MEPP utiliza la realidad aumentada y se basa en datos probados para hacer la rehabilitación facial más accesible.',
      financialTitle: 'Con la ayuda financiera de:',
    },
    description: {
      title: 'La terapia espejo en la rehabilitación facial',
      text: 'El MEPP viene acompañado de una aplicación para dispositivos móviles. Permite a un/a terapeuta ofrecer terapia espejo en la rehabilitación facial, para pacientes/as que padecen parálisis facial. El MEPP ofrece una plataforma a los/las clínicos/as para gestionar una base de ejercicios, producir planes de ejercicios individualizados y añadir varios usuarios. Además, el sitio ofrece un espacio virtual personalizado que permite a las personas que necesitan rehabilitación realizar sus ejercicios.',
      list: {
        title:
          'Se han realizado varios estudios para probar la usabilidad y la efectividad del MEPP:',
        loading: 'Cargando…',
        error: '¡Se produjo un error al cargar!',
      },
    },
    history: {
      title:
        'Aproximadamente <span style="color:#008EDE;">15,4 millones</span> de personas al año en el mundo sufrirán parálisis facial, causada por la parálisis de Bell o un accidente cerebrovascular.',
      text1:
        'Aproximadamente 15.4 millones (M) de personas al año en el mundo sufrirán una parálisis facial, ocasionada por la parálisis de Bell o un accidente cerebrovascular (Feigin et al, 2022). Esto representa aproximadamente 110,000 y aproximadamente 23,000 personas cada año en Canadá y Quebec. Para estas personas, la rehabilitación es esencial para favorecer la recuperación de las funciones y para mejorar su calidad de vida. La rehabilitación se realiza gracias al trabajo conjunto de los pacientes con profesionales de la salud, especializados en la evaluación y rehabilitación de la parálisis facial. Sin embargo, para estos profesionales, actualmente hay muy pocas herramientas especializadas y basadas en datos probados disponibles. Por lo tanto, deben trabajar principalmente explorando, a tientas, una literatura abundante y dispar, lo que obstaculiza la eficacia de sus intervenciones y puede llevar a peores resultados clínicos.',
      text2:
        'Para abordar esta importante problemática, el equipo de investigación formado por la doctora Sarah Martineau, fonoaudióloga y profesora adjunta clínica en la Universidad de Montreal, la doctora Karine Marcotte, fonoaudióloga e investigadora, y el doctor Akram Rahal, otorrinolaringólogo y profesor clínico en la Universidad de Montreal, desarrolló el Protocolo Mirror Effect Plus (MEPP) entre 2017 y 2023. Esta rehabilitación, junto con el sitio web que la acompaña, se basa en principios de intervención importantes en la parálisis facial, así como en la terapia espejo. El sitio integra una progresión de ejercicios y una ayuda visual para facilitar la readaptación de personas con afecciones neurológicas en la cara. El MEPP propone un enfoque personalizado de duplicación facial, único en comparación con los programas de rehabilitación facial disponibles en el mercado. Además, los protocolos de rehabilitación y los ejercicios integrados en el sitio se apoyan en las evidencias más recientes. Por lo tanto, esta herramienta facilita enormemente el trabajo de los profesionales, así como el proceso terapéutico de los pacientes, ya que ofrece una estructura clara, basada en la literatura científica, al tiempo que facilita el acceso a ejercicios en casa y la tele-rehabilitación en el ámbito de la parálisis facial.',
      persons: {
        person1: {
          name: 'Dra. Sarah Martineau',
          title:
            'Fonoaudióloga y profesora asistente clínica en la Universidad de Montreal',
        },
        person2: {
          name: 'Dra. Karine Marcotte',
          title: 'Logopeda e investigadora',
        },
        person3: {
          name: 'Dro. Akram Rahal',
          title: 'ORL y profesor clínico en la Universidad de Montreal',
        },
      },
    },
    donate: {
      title: 'Ayúdanos a hacer que el MEPP sea accesible para todos.',
      text: 'Todas las donaciones apoyan directamente el desarrollo del MEPP, para que podamos proporcionar acceso gratuito a nuestras herramientas a quienes más lo necesitan. Haz una donación hoy mismo.',
    },
  },
};
